export default class detailChange{
    constructor(kv,detail){

        this.kv = kv;
        this.detailShow = detail;

    }

    /* ---------------------------------------------------

　　　-- 詳細の切替え

    --------------------------------------------------- */

    set(direction){

        let _this = this;

        this.kv.status.rendering = false;

        let _progress = 0;
        let _comp = false;
        let _hideTarget = this.kv.detail.querySelector('.is-current');
        this.detailShow.set(direction);


        let tl = new TimelineMax({
            onUpdate:function(){
                _progress = this.progress();
                _progress = Math.ceil(_progress * 100);
                if(_progress >= 15 && !_comp){
                    _comp = true;
                    _this.detailShow.show('change',direction);
                }
            }
        });

        TweenMax.set(_hideTarget.querySelectorAll('.fake-image'), {
            opacity:0,
            display:'none',
        });
        TweenMax.to(_hideTarget.querySelector('.number').children, .3 ,{
            y:'100%',
        });
        TweenMax.to([_hideTarget.querySelector('.en').children,_hideTarget.querySelector('.jp').children,_hideTarget.querySelector('.text'),_hideTarget.querySelector('.pager')], .3 ,{
            opacity:0,
            y:'50px',
            ease: Sine.easeOut,
        });
        switch(direction) {
            case 'next':
                tl.to(_hideTarget, 0.25, {
                    z:0,
                    x: '10%',
                    y: '25%',
                    rotation:-6,
                    transformOrigin: "50% 0%",
                }).to(_hideTarget, 0.6, {
                    z:-15,
                    x: '-100%',
                    y: '-120%',
                    rotation:-15,
                    transformOrigin: "50% 0%",
                });
                break;
            case 'prev':
                tl.to(_hideTarget, 0.25, {
                    z:0,
                    x: '-10%',
                    y: '-25%',
                    rotation:-6,
                    transformOrigin: "50% 100%",
                }).to(_hideTarget, 0.6, {
                    z: -15,
                    x: '100%',
                    y: '120%',
                    rotation:-15,
                    transformOrigin: "50% 100%",
                });
                break;
        }

    }

    comp(){

    }


}